// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mw92","question":"styles_question__257hA","description":"styles_description__lHj50"};